import { Link } from 'react-router-dom';
import { Text, Group, Skeleton, Stack, Anchor } from '@mantine/core';
import { IconTrendingUp } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { hashtagsService } from '../../services/hashtags';

export function PopularSection() {
  const { data: tags = [], isLoading } = useQuery({
    queryKey: ['hashtags-trending-sidebar'],
    queryFn: () => hashtagsService.getTrending(24, 10),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <Stack gap="xs">
      <Group gap="xs">
        <IconTrendingUp size={16} color="var(--mantine-color-dimmed)" />
        <Text size="sm" fw={600}>Popular Topics</Text>
      </Group>

      {isLoading ? (
        <Group gap="xs">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} h={26} w={60 + (i % 3) * 20} radius="xl" />
          ))}
        </Group>
      ) : tags.length === 0 ? (
        <Text size="sm" c="dimmed">No trending tags yet</Text>
      ) : (
        <Stack gap="xs">
          {tags.map((tag) => (
            <Group key={tag.slug} justify="space-between" wrap="nowrap">
              <Anchor
                component={Link}
                to={`/tags/${tag.slug}`}
                size="sm"
                fw={500}
                style={{ textDecoration: 'none' }}
              >
                #{tag.name}
              </Anchor>
              <Text size="xs" c="dimmed">{tag.reviewCount}</Text>
            </Group>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
